import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent } from './components/datatable/datatable.component';
import { ClacMyCloudRoutes } from './clacmycloud.routing';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { ListeRdsComponent } from './pages/ListeRds/liste-rds.component';
import { reducers } from './store/reducers/reducers';
import { StoreModule } from '@ngrx/store';
import { MatDialogModule } from '@angular/material/dialog';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { AlertDialog } from './components/alert/dialog';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ListeEc2Component } from './pages/ListeEc2/liste-ec2.component';
import { ListeGroupComponent } from './pages/ListeGroup/liste-groups.component';
import  {EditGroupComponent}  from  './pages/EditGroup/edit-group.component';
import { AddUserComponent } from './components/add-user/add-user-component';
import { AddResourceComponent } from './components/add-resource/add-resource-component';
import { MatTableResponsiveModule } from 'src/app/directives/mat-table-responsive/mat-table-responsive.module';
import { ListeRolesComponent } from './pages/ListeRole/liste-roles.component';
import { AddRoleComponent } from './components/add-role/add-role-component';
import { ListePermissionComponent } from './pages/ListePermission/liste-permission.component';
import { AddPermissionComponent } from './components/add-permission/add-permission-component';
import { EditPermissionComponent } from './components/edit-permission/edit-permission-component';
import { AddGroupComponent } from './components/add-group/add-group-component';
import { ListeUserComponent } from './pages/ListeUser/liste-users.component';
import { AutocompleteComponent } from 'src/app/common/autocomplete/autocomplete.component';
@NgModule({
  declarations: [
    DataTableComponent,
    ListeRdsComponent,
    ListeEc2Component,
    ListeGroupComponent,
    ListeRolesComponent,
    ListePermissionComponent,
    EditGroupComponent,
    AlertDialog,
    ConfirmDialogComponent,
    AddUserComponent,
    AddResourceComponent,
    AddRoleComponent,
    AddPermissionComponent,
    EditPermissionComponent,
    AddGroupComponent,
    ListeUserComponent,
    AutocompleteComponent,
  ],
  imports: [
    RouterModule.forChild(ClacMyCloudRoutes),
    CommonModule,
    MatTableResponsiveModule,
    MatCardModule,
        MatIconModule,
        MatGridListModule,
        MatSelectModule,
        MatFormFieldModule,
        MatTabsModule,
        MatTooltipModule,
        MatTableModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatChipsModule,
        FlexLayoutModule,
        StoreModule.forFeature('clacmycloud', reducers),
  ]
})
export class ClacmycloudModule { }
